"use strict";
/* eslint-disable functional/functional-parameters */
/* eslint-disable functional/no-return-void */
/* eslint-disable functional/no-expression-statement */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.wrapHistory = exports.defaultSettings = void 0;
var oaf_routing_1 = require("oaf-routing");
exports.defaultSettings = __assign({}, oaf_routing_1.defaultSettings);
var wrapHistory = function (history, settingsOverrides) {
    var settings = __assign(__assign({}, exports.defaultSettings), settingsOverrides);
    var oafRouter = (0, oaf_routing_1.createOafRouter)(settings, function (location) { return location.hash; });
    var initialLocation = history.location;
    // HACK: We use setTimeout to give React a chance to render before we repair focus.
    setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        oafRouter.handleFirstPageLoad(initialLocation);
    }, settings.renderTimeout);
    // eslint-disable-next-line functional/no-let
    var previousLocation = initialLocation;
    var unlisten = history.listen(function (update) {
        // We're the first subscribed listener, so the DOM won't have been updated yet.
        oafRouter.handleLocationWillChange(previousLocation.key, update.location.key, update.action);
        // HACK: We use setTimeout to give React a chance to render before we repair focus.
        var stablePreviousLocation = previousLocation;
        setTimeout(function () {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            oafRouter.handleLocationChanged(stablePreviousLocation, update.location, update.location.key, update.action);
        }, settings.renderTimeout);
        previousLocation = update.location;
    });
    return function () {
        oafRouter.resetAutoScrollRestoration();
        unlisten();
    };
};
exports.wrapHistory = wrapHistory;
